import React, { Component } from "react";

class Filters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            q: this.props.q,
            isFilterOpen: false
        };

        this.onSearchInput = this.onSearchInput.bind(this);
        this.toggleFilter = this.toggleFilter.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.q !== this.props.q) {
            this.setState({
                q: this.props.q
            });
        }
    }

    onSearchInput(e) {
        let value = '';
        if (e.target.value.trim()) {
            value = e.target.value;

        }
        this.setState({
            [e.target.name]: value
        });
        this.props.handleSearchChange(value);
    }

    toggleFilter() {
        this.setState({
            isFilterOpen: !this.state.isFilterOpen
        });
    }

    render() {
        let searchBox;


        if (this.props.showSearch !== false) {
            searchBox =
                <div className="filter-search">
                    <label className="sr-only" htmlFor="filter-search">Search by keyword</label>
                    <input id="filter-search" type="text" name="q" placeholder="Narrow by keyword..." value={
                    this.state.q} onChange={this.onSearchInput} />
                </div>;
        }
        else if (this.props.filterMsg) {
            searchBox =
                <div className="no-search-box">
                    <p className="filter-msg">{this.props.filterMsg}</p>
                </div>;
        }

        return (
            <div className={`filter-expand ${this.state.isFilterOpen ? 'expanded' : ''}`}>
                <button className="filter-expand-btn" type="button" onClick={this.toggleFilter} aria-controls="filters" aria-expanded={this.state.isFilterOpen.toString()}>
                    Filters
                    <span><svg class="icon icon-angle-up"><use xlinkHref="#icon-angle-up"></use></svg></span>
                </button>
                <div id="filters" className="filter">
                    {searchBox}
                    {this.props.children}
                </div>
            </div>
        );
    }
}

Filters.defaultProps = {
    q: '',
    handleSearchChange: function () { },
    filterMsg: 'Filter your search below...'
};

export default Filters;